module.exports = __webpack_public_path__ + "static/media/result_fh_id.ddbcc7e9.jpg";